const cloudinary = (c) => {
    let params = [
        c.height ? `h_${ c.height * (c.dpr || 1) }` : null,
        c.width ? `w_${ c.width * (c.dpr || 1) }` : null,
        'f_auto',
        'q_auto',
        'c_pad',
        c.transparent ? null : `b_white`,
    ].filter(e => e != null).join(',');

    return `https://${ c.host || 'media.deporvillage.com' }/${ params }/${ c.src }`;
};

export default cloudinary;
